/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polite_Happy_Bumblebee_CareInputs */

const fr_polite_happy_bumblebee_care = /** @type {(inputs: Polite_Happy_Bumblebee_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine précédente`)
};

/**

* @param {Polite_Happy_Bumblebee_CareInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const polite_happy_bumblebee_care = /** @type {((inputs?: Polite_Happy_Bumblebee_CareInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polite_Happy_Bumblebee_CareInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_polite_happy_bumblebee_care(inputs)
});